var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWork(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_889_6627",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_889_6627)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33366 17.5001C2.87533 17.5001 2.48296 17.3369 2.15658 17.0105C1.83019 16.6841 1.66699 16.2917 1.66699 15.8334V6.66675C1.66699 6.20841 1.83019 5.81605 2.15658 5.48966C2.48296 5.16328 2.87533 5.00008 3.33366 5.00008H6.66699V3.33341C6.66699 2.87508 6.83019 2.48272 7.15658 2.15633C7.48296 1.82994 7.87533 1.66675 8.33366 1.66675H11.667C12.1253 1.66675 12.5177 1.82994 12.8441 2.15633C13.1705 2.48272 13.3337 2.87508 13.3337 3.33341V5.00008H16.667C17.1253 5.00008 17.5177 5.16328 17.8441 5.48966C18.1705 5.81605 18.3337 6.20841 18.3337 6.66675V15.8334C18.3337 16.2917 18.1705 16.6841 17.8441 17.0105C17.5177 17.3369 17.1253 17.5001 16.667 17.5001H3.33366ZM3.33366 15.8334H16.667V6.66675H3.33366V15.8334ZM8.33366 5.00008H11.667V3.33341H8.33366V5.00008Z",
    fill: "#EE682B"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWork);
export default __webpack_public_path__ + "static/media/work.b2be4ff25844432a53e8f9f8827c1588.svg";
export { ForwardRef as ReactComponent };